import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useMyInvites, useAcceptInvite, useDeclineInvite } from '../hooks';
import { InviteEntry } from './InviteEntry';
import { UserProfileSection } from './section';

/**
 * Renders the pending invitations section for the user profile.
 * Only shown when showCreateCompany is true and there are pending invites.
 * Handles accept/decline actions with toast feedback.
 */
export function UserInvitesSection() {
  const { t } = useTranslation();
  const { data: invitesData } = useMyInvites();
  const acceptInvite = useAcceptInvite();
  const declineInvite = useDeclineInvite();

  const invites = invitesData?.invites ?? [];

  const handleAccept = async (inviteId: string) => {
    try {
      await acceptInvite.mutateAsync(inviteId);
      toast.success(t('userProfile.invites.acceptSuccess'));
    } catch {
      toast.error(t('userProfile.invites.acceptError'));
    }
  };

  const handleDecline = async (inviteId: string) => {
    try {
      await declineInvite.mutateAsync(inviteId);
      toast.success(t('userProfile.invites.declineSuccess'));
    } catch (e) {
      console.log("ERROR e", e)
      toast.error(t('userProfile.invites.declineError'));
    }
  };

  if (invites.length === 0) return null;

  return (
    <UserProfileSection headline={t('userProfile.invites.headline')}>
      <div className="space-y-3">
        {invites.map((invite) => (
          <InviteEntry
            key={invite.id}
            invite={invite}
            onAccept={(id) => void handleAccept(id)}
            onDecline={(id) => void handleDecline(id)}
            isAccepting={acceptInvite.isPending && acceptInvite.variables === invite.id}
            isDeclining={declineInvite.isPending && declineInvite.variables === invite.id}
          />
        ))}
      </div>
    </UserProfileSection>
  );
}
